import React from 'react';

const Inventory = () => {
    return (
        <div>
            <h2>Inventory </h2>
        </div>
    );
};

export default Inventory;